import { render, staticRenderFns } from "./AccountOrderWrap.vue?vue&type=template&id=0f33369e"
import script from "./AccountOrderWrap.vue?vue&type=script&lang=js"
export * from "./AccountOrderWrap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports